import type { Element as XmlEl } from "@xmpp/xml"
import { unwrapCarbon } from "../carbons"
import { unwrapMamResult } from "../mam"
import { unwrapMucsub } from "../mucsub"

/** Each returns the message it contained, or null when it doesn't apply. */
const UNWRAPPERS = [unwrapMucsub, unwrapMamResult, unwrapCarbon]

/**
 * Strip envelopes until a plain message is left.
 *
 * Recursive because they nest: a group row in your archive is a MAM result
 * holding the wrapped mucsub copy. Each unwrapper hoists its own `<delay>` on
 * the way down, so the outermost stamp — the authoritative one — ends up on
 * the message.
 */
export function unwrap(stanza: XmlEl): XmlEl {
  for (const unwrapper of UNWRAPPERS) {
    const inner = unwrapper(stanza)
    if (inner) return unwrap(inner)
  }

  return stanza
}
